import Fops from './Fops.redux';

export default Fops;
